export default '/static/frontend/ReachDigital/12gobiking/dist/assets/afterpay-73163781.svg'